import type { ComponentProps, FC } from "react";

import { EditorButtonBlockquote, EditorButtonCode, EditorButtonCodeBlock, EditorButtonHr } from "../editor-buttons";
import { EditorButtonGroup } from "./editor-button-group";

export const EditorButtonGroupSecondaryFormattingBlocks: FC<ComponentProps<typeof EditorButtonGroup>> = (props) => (
  <EditorButtonGroup {...props}>
    <EditorButtonHr />
    <EditorButtonBlockquote />
    <EditorButtonCode />
    <EditorButtonCodeBlock />
  </EditorButtonGroup>
);
